/* ##################################################################
	SETUP MAP DATA
################################################################## */

var pmap = {}
	pmap.container = $('#map');
	pmap.activity = pmap.container.data('activity');
	pmap.parkslug = pmap.container.data('parkslug');
	pmap.type = pmap.container.data('type');
	pmap.activitiesfilter = {
		"hiking": "biking_hik = 'Y'",
		"mountain-biking": "biking_hik = 'Y'",
		"water-sports": "boating = 'Y'",
		"museums": "Museums = 'Y'",
		"boating": "boating = 'Y'",
		"golf": "golf = 'Y'",
		"fishing": "fishing = 'Y'",
		"camping": "camping = 'Y'",
		"equestrian": "equestrian = 'Y'",
		"ohv": "ohv = 'Y'",
		"winter": "winter_use = 'Y'"
	} // slug : Prototype
	pmap.activityDefEx = pmap.activitiesfilter[pmap.activity];
	pmap.parklatlng = {
		"anasazi": "-111.42349,37.910902,17",
		"antelope-island": "-112.202635,40.970108,12",
		"bear-lake": "-111.39922,41.96493,16",
		"camp-floyd": "-112.09336,40.258,15",
		"coral-pink": "-112.720278,37.037778,13",
		"dead-horse": "-109.73,38.50,13",
		"deer-creek": "-111.496152,40.416085,13",
		"east-canyon": "-111.587074,40.901135,13",
		"edge-of-the-cedars": "-109.4921,37.631826,16",
		"escalante-petrified-forest": "-111.615176,37.78973,14",
		"flight-park": "-111.901385,40.457842,15",
		"fremont-indian": "-112.32,38.576236,13",
		"frontier-homestead": "-113.0635,37.688631,17",
		"goblin-valley": "-110.706749,38.564,14",
		"goosenecks": "-109.926952,37.174352,13",
		"great-salt-lake": "-112.211056,40.733748,15",
		"green-river": "-110.154719,38.990034,15",
		"gunlock": "-113.77072,37.254376,14",
		"historic-union-pacific-rail-trail": "-111.4054058,40.956518,13",
		"huntington": "-110.946938,39.345568,15",
		"hyrum": "-111.866589,41.615,14",
		"jordan-river": "-111.943,40.825417,15",
		"jordanelle": "-111.42045,40.620708,13",
		"kodachrome-basin": "-111.993982,37.516149,14",
		"millsite": "-111.193945,39.092042,16",
		"otter-creek": "-112.018574,38.1664,16",
		"palisade": "-111.665556,39.206389,15",
		"piute": "-112.196301,38.319319,16",
		"quail-creek": "-113.385278,37.1925,14",
		"red-fleet": "-109.432211,40.58015,14",
		"rockport": "-111.394798,40.770655,13",
		"sand-hollow": "-113.3764,37.115746,13",
		"scofield": "-111.15,39.7801884,13",
		"snow-canyon": "-113.641389,37.203056,13",
		"starvation": "-110.467918,40.182978,13",
		"steinaker": "-109.537,40.516,14",
		"territorial-statehouse": "-112.325395,38.967202,17",
		"heritage-park": "-111.812069,40.751288,15",
		"utah-field-house": "-109.51973,40.455339,17",
		"utah-lake": "-111.736212,40.23784,15",
		"wasatch-mountain": "-111.483,40.549,13",
		"willard-bay": "-112.08,41.38,13",
		"yuba": "-111.98,39.376373,13",
	}
	pmap.parkcenter = pmap.parklatlng[pmap.parkslug];

	// console.log(pmap.activityDefEx);
	// console.log(pmap.parkcenter);

/* ##################################################################
	ArcGIS API
################################################################## */

require([
		'esri/map',
        'esri/InfoTemplate',
        'esri/layers/FeatureLayer',
        'esri/dijit/Legend',
		'dojo/domReady!'
	],
	function (
		Map, InfoTemplate, FeatureLayer, Legend
		)
	{ 
		var map = new Map('map', {
			center: [-111.7,39.5],
			zoom: 7,
			basemap: 'topo',
			sliderStyle: 'small'
		});
		map.on('load', function() {

			// SETUP PARK INFO TEMPLATE
			var parkinfo = {};
				parkinfo.parkshtml =  	'<table cellspacing="0px" cellpadding="0px" class="attrTable">';
				parkinfo.parkshtml += 	'<tr valign="top">';
				parkinfo.parkshtml += 	'<td class="attrName">Park Name:</td><td class="attrValue">${name}</td>';
				parkinfo.parkshtml += 	'</tr><tr valign="top">';
				parkinfo.parkshtml += 	'<td class="attrName">Region:</td><td class="attrValue">${region}</td>';
				parkinfo.parkshtml += 	'</tr><tr valign="top">';
				parkinfo.parkshtml += 	'<td class="attrName">Park Website:</td><td class="attrValue"><a href="${UT_State_Park_website}">More Info</a></td>';
				parkinfo.parkshtml += 	'</tr>';
				parkinfo.parkshtml += 	'</table>';

				parkinfo.areahtml = 	 '<a href="${weblink1}">${name}</a>';
				parkinfo.recpointshtml = '${ParkRecPnt}';

				parkinfo.sitesinfo =  '<table cellspacing="0px" cellpadding="0px" class="attrTable">';
				parkinfo.sitesinfo += '<tr valign="top">';
				parkinfo.sitesinfo += '<td class="attrName">Park:</td><td class="attrValue">${ParkName} </td>';
				parkinfo.sitesinfo += '</tr><tr valign="top">';
				parkinfo.sitesinfo += '<td class="attrName">Use Area:</td><td class="attrValue">${UseArea} </td>';
				parkinfo.sitesinfo += '</tr><tr valign="top">';
				parkinfo.sitesinfo += '<td class="attrName">Site No:</td><td class="attrValue">${SiteNo} </td>';
				parkinfo.sitesinfo += '</tr><tr valign="top">';
				parkinfo.sitesinfo += '<td class="attrName">Campground Name:</td><td class="attrValue">${CampgrdName} </td>';
				parkinfo.sitesinfo += '</tr><tr valign="top">';
				parkinfo.sitesinfo += '<td class="attrName">Loop Name:</td><td class="attrValue">${LoopName} </td>';
				parkinfo.sitesinfo += '</tr><tr valign="top">';
				parkinfo.sitesinfo += '<td class="attrName">Site Res Type:</td><td class="attrValue">${SiteResType} </td>';
				parkinfo.sitesinfo += '</tr><tr valign="top">';
				parkinfo.sitesinfo += '<td class="attrName">Site Type:</td><td class="attrValue">${SiteType} </td>';
				parkinfo.sitesinfo += '</tr><tr valign="top">';
				parkinfo.sitesinfo += '<td class="attrName">Facility Name:</td><td class="attrValue">${FacilityName} </td>';
				parkinfo.sitesinfo += '</tr><tr valign="top">';
				parkinfo.sitesinfo += '<td class="attrName">Access:</td><td class="attrValue">${Access} </td>';
				parkinfo.sitesinfo += '</tr><tr valign="top">';
				parkinfo.sitesinfo += '<td class="attrName">ADA:</td><td class="attrValue">${ADA} </td>';
				parkinfo.sitesinfo += '</tr><tr valign="top">';
				parkinfo.sitesinfo += '<td class="attrName">Max Occupant:</td><td class="attrValue">${MaxOccupant} </td>';
				parkinfo.sitesinfo += '</tr><tr valign="top">';
				parkinfo.sitesinfo += '<td class="attrName">Max Vehicle Length:</td><td class="attrValue">${MaxVehicleLength} </td>';
				parkinfo.sitesinfo += '</tr><tr valign="top">';
				parkinfo.sitesinfo += '<td class="attrName">Allowed Vehicles:</td><td class="attrValue">${NumAllowVehicles} </td>';
				parkinfo.sitesinfo += '</tr><tr valign="top">';
				parkinfo.sitesinfo += '<td class="attrName">Tent pad:</td><td class="attrValue">${Tentpad} </td>';
				parkinfo.sitesinfo += '</tr><tr valign="top">';
				parkinfo.sitesinfo += '<td class="attrName">Tent pad Size:</td><td class="attrValue">${TentpadSize} </td>';
				parkinfo.sitesinfo += '</tr><tr valign="top">';
				parkinfo.sitesinfo += '<td class="attrName">Surface:</td><td class="attrValue">${Surface} </td>';
				parkinfo.sitesinfo += '</tr><tr valign="top">';
				parkinfo.sitesinfo += '<td class="attrName">View:</td><td class="attrValue">${View_} </td>';
				parkinfo.sitesinfo += '</tr><tr valign="top">';
				parkinfo.sitesinfo += '<td class="attrName">Pets:</td><td class="attrValue">${Pets} </td>';
				parkinfo.sitesinfo += '</tr><tr valign="top">';
				parkinfo.sitesinfo += '<td class="attrName">Picnic Table:</td><td class="attrValue">${PicnicTable} </td>';
				parkinfo.sitesinfo += '</tr><tr valign="top">';
				parkinfo.sitesinfo += '<td class="attrName">Grill:</td><td class="attrValue">${Grill} </td>';
				parkinfo.sitesinfo += '</tr><tr valign="top">';
				parkinfo.sitesinfo += '<td class="attrName">Fire Pit:</td><td class="attrValue">${FirePit} </td>';
				parkinfo.sitesinfo += '</tr><tr valign="top">';
				parkinfo.sitesinfo += '<td class="attrName">Electrical HookupAmps:</td><td class="attrValue">${ElectricalHookupAmps} </td>';
				parkinfo.sitesinfo += '</tr><tr valign="top">';
				parkinfo.sitesinfo += '<td class="attrName">Water Hookup:</td><td class="attrValue">${WaterHookup} </td>';
				parkinfo.sitesinfo += '</tr><tr valign="top">';
				parkinfo.sitesinfo += '<td class="attrName">Sewer Hookup:</td><td class="attrValue">${SewerHookup} </td>';
				parkinfo.sitesinfo += '</tr><tr valign="top">';
				parkinfo.sitesinfo += '<td class="attrName">Shade:</td><td class="attrValue">${Shade} </td>';
				parkinfo.sitesinfo += '</tr><tr valign="top">';
				parkinfo.sitesinfo += '<td class="attrName">Restrictions:</td><td class="attrValue">${Restrictions} </td>';
				parkinfo.sitesinfo += '</tr><tr valign="top">';
				parkinfo.sitesinfo += '<td class="attrName">Park Website:</td><td class="attrValue"><a href="${Weblink2}">More Info</a> </td>';
				parkinfo.sitesinfo += '</tr><tr valign="top">';
				parkinfo.sitesinfo += '<td class="attrName">Reservations:</td><td class="attrValue"><a href="${Weblink3}">More Info</a> </td>';
				parkinfo.sitesinfo += '</tr><tr valign="top">';
				parkinfo.sitesinfo += '<td class="attrName">Comments:</td><td class="attrValue">${Comments} </td>';
				parkinfo.sitesinfo += '</tr>';
				parkinfo.sitesinfo += '</table>';

				parkinfo.trailsinfo =  '<table cellspacing="0px" cellpadding="0px" class="attrTable">';
				parkinfo.trailsinfo += '<tr valign="top">';
				parkinfo.trailsinfo += '<td class="attrName">Name:</td><td class="attrValue">${name} </td>';
				parkinfo.trailsinfo += '</tr><tr valign="top">';
				parkinfo.trailsinfo += '<td class="attrName">Use:</td><td class="attrValue">${use_} </td>';
				parkinfo.trailsinfo += '</tr><tr valign="top">';
				parkinfo.trailsinfo += '<td class="attrName"></td><td class="attrValue">${uses} </td>';
				parkinfo.trailsinfo += '</tr><tr valign="top">';
				parkinfo.trailsinfo += '<td class="attrName">Surface Type:</td><td class="attrValue">${surface} </td>';
				parkinfo.trailsinfo += '</tr><tr valign="top">';
				parkinfo.trailsinfo += '<td class="attrName">Restrictions:</td><td class="attrValue">${restrictions} </td>';
				parkinfo.trailsinfo += '</tr><tr valign="top">';
				parkinfo.trailsinfo += '<td class="attrName">Length:</td><td class="attrValue">${Calculated_Length_Miles} Miles (${Calculated_Length_km} </td>';
				parkinfo.trailsinfo += '</tr>';
				parkinfo.trailsinfo += '</table>';


			var parksinfoTemplate = new InfoTemplate('${name}', parkinfo.parkshtml);
			var parksLayer = new FeatureLayer('https://services.arcgis.com/ZzrwjTRez6FJiOq4/arcgis/rest/services/Utah_State_Parks/FeatureServer/0',{
				mode: FeatureLayer.MODE_ONDEMAND,
				infoTemplate: parksinfoTemplate,
				outFields: ['*']
			});
			
			var areainfoTemplate = new InfoTemplate('${name}', parkinfo.areahtml);
			var areaLayer = new FeatureLayer('https://services.arcgis.com/ZzrwjTRez6FJiOq4/arcgis/rest/services/Utah_State_Park_Management_Areas/FeatureServer/0',{
				mode: FeatureLayer.MODE_ONDEMAND,
				infoTemplate: areainfoTemplate,
				outFields: ['*']
			});

			var trailsinfoTemplate = new InfoTemplate('${name}', parkinfo.trailsinfo);
			var trailsLayer = new FeatureLayer('https://services.arcgis.com/ZzrwjTRez6FJiOq4/arcgis/rest/services/DPRTrails/FeatureServer/0',{
				mode: FeatureLayer.MODE_ONDEMAND,
				infoTemplate: trailsinfoTemplate,
				outFields: ['*']
			});

			var sitesinfoTemplate = new InfoTemplate('${CampgrdName} - ${SiteNo}', parkinfo.sitesinfo);
			var sitesLayer = new FeatureLayer('https://services.arcgis.com/ZzrwjTRez6FJiOq4/arcgis/rest/services/DPRCampsitesandDayUse/FeatureServer/0',{
				mode: FeatureLayer.MODE_ONDEMAND,
				infoTemplate: sitesinfoTemplate,
				outFields: ['*']
			});


			if (pmap.type != 'activities') {

				var recpointsinfoTemplate = new InfoTemplate('${ParkRecPnt}', parkinfo.recpointshtml);
				var recpointsLayer = new FeatureLayer('https://services.arcgis.com/ZzrwjTRez6FJiOq4/arcgis/rest/services/DPRRecreationPoints/FeatureServer/0',{
					mode: FeatureLayer.MODE_ONDEMAND,
					infoTemplate: recpointsinfoTemplate,
					outFields: ['*']
				});

				var landmarksinfoTemplate = new InfoTemplate('${Landmark_Type}', '${name}');
				var landmarksLayer = new FeatureLayer('https://services.arcgis.com/ZzrwjTRez6FJiOq4/arcgis/rest/services/DPRLandmarkFeatures/FeatureServer/0',{
					mode: FeatureLayer.MODE_ONDEMAND,
					infoTemplate: landmarksinfoTemplate,
					outFields: ['*']
				});

			} // end if not actitivies

				

			if (pmap.activity) {
				parksLayer.setDefinitionExpression(pmap.activityDefEx);
			}

			if (pmap.parkcenter) {
				pmap.parkcenter = pmap.parkcenter.split(',');
				var parkcenter = new esri.geometry.Point(pmap.parkcenter[0], pmap.parkcenter[1]);
				var parkzoom = pmap.parkcenter[2];
				map.centerAndZoom(parkcenter,parkzoom);
			}
			
	    	//map.addLayer(landmarksLayer);
	    	//map.addLayer(recpointsLayer);
	    	map.addLayer(parksLayer);
	    	

	    	// Get zoom level
			map.on('extent-change', function(){
				if (pmap.type != 'activities') {
					var zoomlevel = map.getLevel();
					//console.log(zoomlevel);
					if (zoomlevel >= 10) {
			    		map.addLayer(areaLayer);
			    		map.addLayer(sitesLayer);
			    		map.addLayer(trailsLayer);
			    		map.addLayer(recpointsLayer);
			    		map.addLayer(landmarksLayer);
			    		recpointsLayer.show();
						landmarksLayer.show();
						areaLayer.show();
						trailsLayer.show();
						sitesLayer.show();
					} else {
						recpointsLayer.hide();
						landmarksLayer.hide();
						areaLayer.hide();
						trailsLayer.hide();
						sitesLayer.hide();
					}
				}
			})
		});
		

	} //function
); //require

